import React, { useState, useEffect, useCallback, useRef } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import classes from "./css/mobile-sticky-navbar.module.scss";

import algoliasearch from "algoliasearch/lite";
import SearchDrawer from "./search-drawer";
import store from "../../store";

const StickyNavbar = (props) => {
  const navbarRef = useRef(null);
  const [showModal, setShowModal] = useState(false);
  const [search, setSearch] = useState(null);
  const [searchResults, setSearchResults] = useState([]);
  const [totalProducts, setTotalProducts] = useState(0);
  const [isSearching, setIsSearching] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          document.body.classList.add("mobile-sticky-navbar-visible");
        } else {
          document.body.classList.remove("mobile-sticky-navbar-visible");
        }
      },
      { threshold: 0 },
    );

    if (navbarRef.current) {
      observer.observe(navbarRef.current);
    }

    return () => {
      observer.disconnect();
      document.body.classList.remove("mobile-sticky-navbar-visible");
    };
  }, []);

  const searchClient = algoliasearch(
    window.rc.algoliasearch.appId,
    window.rc.algoliasearch.apiKey,
  );
  const index = searchClient.initIndex(window.rc.algoliasearch.defaultIndex);

  function debounce(func) {
    var timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        timeout = null;
        func.apply(undefined, args);
      }, 200);
    };
  }

  const handleSearch = useCallback(
    debounce((search) => {
      index
        .search(search, {
          hitsPerPage: 6,
        })
        .then(({ hits, nbHits }) => {
          setSearchResults(hits);
          setTotalProducts(nbHits);
        })
        .catch((error) => console.error(error));
    }),
    [],
  );

  useEffect(() => {
    if (search) {
      setIsSearching(true);
      handleSearch(search);
    }
  }, [search]);

  useEffect(() => {
    setIsSearching(false);
  }, [searchResults]);

  const displayModal = (event) => {
    setShowModal(event);
  };

  const toggleChat = () => {
    // setIsChatOpen(!isChatOpen);
    store.dispatch({ type: "WHATSAPP_CHAT" });
  };

  return (
    <div ref={navbarRef} className={`${classes.mob_sticky_navbar} d-md-none`}>
      <ul className={`${classes.option_list} m-0 p-0`}>
        <li className={classes.option_list_item}>
          <Link
            className={classes.option_list_item_inner}
            to={`${process.env.PUBLIC_URL}/`}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M3.47518 20.5H3.47768C6.03457 20.5 9.142 20.5 12 20.5M3.47518 20.5C3.47798 20.5 3.47859 20.5 3.47518 20.5ZM3.47518 20.5L3.47389 10.0792C3.47383 9.8036 3.53389 9.53129 3.6499 9.28128C3.7659 9.03127 3.93506 8.80958 4.14556 8.63167L10.777 2.9476C11.119 2.65857 11.5522 2.5 12 2.5C12.4477 2.5 12.881 2.65857 13.223 2.9476L19.8544 8.63167C20.0649 8.80958 20.2341 9.03127 20.3501 9.28128C20.4661 9.53129 20.5262 9.8036 20.5261 10.0792V20.5C20.5261 20.5 16.5839 20.5 12 20.5M12 20.5V11"
                stroke="black"
                strokeLinecap="square"
              />
            </svg>
            <p className={`${classes.option_list_item_text} m-0 p-0`}>Home</p>
          </Link>
        </li>
        <li className={classes.option_list_item}>
          <Link
            className={classes.option_list_item_inner}
            to={`${process.env.PUBLIC_URL}${localStorage.getItem("api_token") ? "/dashboard" : "/login"}`}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="22"
              height="22"
              viewBox="0 0 22 22"
              fill="none"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.0181 6.57095C15.0181 8.80898 13.2035 10.6224 10.9667 10.6224C8.72865 10.6224 6.91406 8.80898 6.91406 6.57095C6.91406 4.33292 8.72865 2.51953 10.9667 2.51953C13.2035 2.51953 15.0181 4.33292 15.0181 6.57095Z"
                stroke="black"
                strokeLinecap="square"
              />
              <path
                d="M18.3327 19.252C17.3998 16.3017 15.1243 13.586 10.9993 13.586C6.8742 13.586 4.60001 16.2985 3.66602 19.252"
                stroke="black"
                strokeLinecap="square"
              />
            </svg>
            <p className={`${classes.option_list_item_text} m-0 p-0`}>
              Profile
            </p>
          </Link>
        </li>
        <li className={classes.option_list_item}>
          <a onClick={toggleChat}>
            <img
              src="/assets/gif/whatsapp-new.gif"
              alt="WhatsApp Chat"
              width="42"
              height="42"
              style={{ display: "inline-block", verticalAlign: "middle" }}
            />
          </a>
        </li>
        <li className={classes.option_list_item}>
          <Link
            className={classes.option_list_item_inner}
            to={`${process.env.PUBLIC_URL}/cart`}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="22"
              height="22"
              viewBox="0 0 22 22"
              fill="none"
            >
              <path
                d="M15.3555 8.38839V7.36915C15.3555 4.96476 13.4063 3.01562 11.002 3.01562C8.59758 3.01562 6.64844 4.96476 6.64844 7.36915V8.38839"
                stroke="black"
                strokeLinecap="square"
                strokeLinejoin="round"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18.5053 18.9844L19.4798 6.74454L2.52148 6.74454L3.49596 18.9844L18.5053 18.9844Z"
                stroke="black"
                strokeLinecap="round"
              />
            </svg>
            {props.cartList.length > 0 && (
              <span className={classes.cart_count}>
                {props.cartList.length}
              </span>
            )}
            <p className={`${classes.option_list_item_text} m-0 p-0`}>Cart</p>
          </Link>
        </li>
        <li
          className={classes.option_list_item}
          onClick={() => displayModal(true)}
        >
          <div className={classes.option_list_item_inner}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <circle
                cx="10.9963"
                cy="10.7885"
                r="8.03854"
                stroke="black"
                strokeLinecap="square"
              />
              <path
                d="M16.4859 16.709L21.0394 21.2506"
                stroke="black"
                strokeLinecap="square"
              />
            </svg>
            <p className={`${classes.option_list_item_text} m-0 p-0`}>Search</p>
          </div>
        </li>
      </ul>

      <SearchDrawer
        show={showModal}
        onClose={() => displayModal(false)}
        search={search}
        onSearchChange={(value) => setSearch(value)}
        searchResults={searchResults}
        isSearching={isSearching}
        totalProducts={totalProducts}
      />
    </div>
  );
};

function mapStateToProps(state) {
  return { cartList: state.cartList.cart };
}
export default connect(mapStateToProps)(StickyNavbar);
